import styled from "styled-components";
import { RowContents, WrapPrice, WrapSliderPrice } from "../../styled";

export const RemoveContainer = styled.div`
  & > h2 {
    margin-bottom: 25px;
  }
  ${WrapSliderPrice} {
    margin-bottom: 20px;
  }
  ${WrapPrice} {
    margin-bottom: 20px;
  }
  ${RowContents} {
    &:not(:last-child) {
      margin-bottom: 12px;
    }
    & > p {
      color: #fff;
    }
  }
`;
